document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector("#openPopup");
  const popupForm = document.querySelector("#popupForm");
  const closeBtn = document.querySelector("#closePopup");
  const popupContent = document.querySelector(".popup-form__contnet");

  openBtn.addEventListener("click", function () {
    popupForm.classList.add("opened");
  });
  closeBtn.addEventListener("click", function () {
    popupForm.classList.remove("opened");
  });
  document.addEventListener("click", function (event) {
    if (
      !popupContent.contains(event.target) &&
      !openBtn.contains(event.target)
    ) {
      popupForm.classList.remove("opened");
    }
  });
});
